import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const ExploreMoreMusic: React.FC = () => {
  const { currentTheme } = useTheme();

  return (
    <section className={`bg-gradient-to-br ${currentTheme.colors.primary} text-white py-12 px-6`}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mx-auto text-center"
      >
        <h2 className="text-3xl md:text-4xl font-bold mb-3">Love this song?</h2>
        <p className="text-lg text-purple-200 mb-6">
          Explore more original songs by Mukesh Rathore.
        </p>
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="inline-block">
          <Link
            to="/music"
            className="inline-block bg-white text-purple-700 font-bold py-4 px-10 rounded-full text-lg shadow-2xl min-h-[56px]"
          >
            Explore Music
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default ExploreMoreMusic;
